export default function log(s) {
  console.info('[react-ga]', s);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ga/dist/esm/utils/console/log.js
// module id = 1073
// module chunks = 58